import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { LockKey, Crown } from "@phosphor-icons/react";

// VIP inclut toujours tout ce que Pro offre (3 sports + IA + analyse
// humaine) -> ne jamais exclure les VIP d'une fonctionnalité "Pro".
export const isPro = (user) => user?.role === "admin" || user?.plan === "pro" || user?.plan === "vip";

export const ProGate = ({ user, children, label, note, testid, to }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const gateLabel = label || t("progate.unlock");
  if (isPro(user)) return children;
  return (
    <div className="relative overflow-hidden rounded-xl" data-testid={testid || "pro-gate"}>
      <div className="pointer-events-none select-none blur-[6px] opacity-40" aria-hidden="true">
        {children}
      </div>
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 text-center px-4"
        style={{ background: "linear-gradient(180deg, rgba(10,10,10,0.55), rgba(10,10,10,0.8))" }}>
        <div className="w-10 h-10 rounded-full flex items-center justify-center bg-gold/15 border border-gold/50">
          <LockKey size={18} weight="fill" color="#D4AF37" />
        </div>
        {note && <p className="text-[11px] text-white/60 max-w-[240px] leading-snug">{note}</p>}
        <button
          data-testid="progate-cta"
          onClick={() => navigate(to || "/passer-pro")}
          className="mt-1 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-gold text-black text-xs font-bold glow-gold hover:bg-gold-dark transition-colors"
        >
          <Crown size={14} weight="fill" /> {gateLabel}
        </button>
      </div>
    </div>
  );
};
